import NotificationsViewController from './NotificationsViewController';

export default NotificationsViewController;
